// 외부 URL을 여는 공용 헬퍼
// - Capacitor 네이티브 앱: AppLauncher.openUrl() 사용 (외부 브라우저/앱 실행)
// - 웹: window.open() 사용
// - 실패 시 fallback 처리

export async function openExternalUrl(url) {
  try {
    const { Capacitor } = await import("@capacitor/core");
    const isNative = Capacitor.isNativePlatform();

    if (isNative) {
      try {
        const { AppLauncher } = await import("@capacitor/app-launcher");
        const can = await AppLauncher.canOpenUrl({ url });
        if (can.value) {
          await AppLauncher.openUrl({ url });
          return true;
        }
      } catch (e) {
        console.warn("[openExternalUrl] AppLauncher failed:", e);
      }

      // AppLauncher fallback: Capacitor Browser (인앱 브라우저)
      try {
        const { Browser } = await import("@capacitor/browser");
        await Browser.open({ url });
        return true;
      } catch (e) {
        console.warn("[openExternalUrl] Browser failed:", e);
      }

      // 최후 fallback: window.location.href
      window.location.href = url;
      return true;
    }

    // 웹 환경: 새 창
    window.open(url, "_blank", "noopener,noreferrer");
    return true;
  } catch (err) {
    console.error("[openExternalUrl] fatal:", err);
    try {
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (_) {}
    return false;
  }
}
